import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { ButtonLoadable } from '@/components/ui/button-loadable';
import { SimpleTooltip } from '@/components/ui/simple-tooltip';

import { SettingsFooterState } from '../types/settings-footer';

interface SettingsFooterProps {
  state: SettingsFooterState;
}

export function SettingsFooter({ state }: SettingsFooterProps) {
  const { t } = useTranslation('common');

  if (!state.isVisible) {
    return null;
  }

  const isDisabled = !state.isEnabled || state.isLoading;
  const showDisabledReason = isDisabled && !state.isLoading && !!state.disabledReason;

  const saveButton = (
    <ButtonLoadable
      onClick={state.onSave}
      isLoading={state.isLoading}
      disabled={isDisabled}
      icon={showDisabledReason ? <Info className="h-4 w-4" /> : undefined}
    >
      {state.isLoading ? (state.savingLabel ?? t('saving')) : (state.saveLabel ?? t('saveChanges'))}
    </ButtonLoadable>
  );

  return (
    <div className="sticky bottom-0 z-[5] w-full border-t border-border bg-surface px-4 py-3 shadow-[0_-1px_4px_0_hsl(var(--border))]">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">{state.leftAction}</div>
        <div className="flex items-center gap-2">
          {state.cancelAction}
          {showDisabledReason ? (
            <SimpleTooltip content={state.disabledReason}>
              <span className="inline-flex">{saveButton}</span>
            </SimpleTooltip>
          ) : (
            saveButton
          )}
        </div>
      </div>
    </div>
  );
}
